<template>
  <v-card
    v-if="canSendPreview"
    border
    :color="successfullySentPreview ? 'success' : 'info'"
    variant="outlined"
    class="mt-0"
    :style="cardStyle"
  >
    <v-card-text class="pa-5 pb-4">
      <p
        v-if="successfullySentPreview"
        class="text-body-large d-flex justify-content-between gap-2 ma-0"
        style="color: white"
      >
        <v-icon
          class="align-self-center"
          color="white"
          >mdi-check-circle</v-icon
        >

        <span class="align-self-center">
          {{ t('invitation-preview.success-title', { email }) }}
        </span>

        <v-icon
          class="align-self-center cursor-pointer"
          color="white"
          @click="hideSuccess"
        >
          mdi-close-circle
        </v-icon>
      </p>

      <template v-else>
        <v-btn
          color="info"
          variant="outlined"
          class="mb-3 w-full"
          :disabled="isSendingPreview"
          :loading="isSendingPreview"
          @click="onSendPreview"
        >
          <v-icon
            start
            size="small"
            >mdi-email-fast-outline</v-icon
          >
          {{ t('buttons.invitation-preview.cta') }}
        </v-btn>

        <p class="mb-0 text-body-large">
          {{ t('invitation-preview.title', { email }) }}
        </p>
      </template>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  email: string
  isSendingPreview?: boolean
  successfullySentPreview?: boolean
  canSendPreview?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isSendingPreview: false,
  successfullySentPreview: false,
  canSendPreview: true,
})

const emit = defineEmits<{
  (e: 'send-preview'): void
  (e: 'dismiss-success'): void
  (e: 'show-success'): void
}>()

const { t } = useI18n()

const cardStyle = computed(() => ({
  backgroundColor: props.successfullySentPreview ? '#5EB035' : '',
  borderRadius: props.successfullySentPreview ? '' : '10px !important',
}))

function onSendPreview() {
  emit('send-preview')
}

function showSuccess() {
  emit('show-success')
}
function hideSuccess() {
  emit('dismiss-success')
}

defineExpose({ showSuccess, hideSuccess })
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
